import { render, staticRenderFns } from "./_ChangePasswordModal.vue?vue&type=template&id=3806bb14&"
import script from "./_ChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./_ChangePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./_ChangePasswordModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports